import dynamic from 'next/dynamic';

export const LazyAboutUsHeroAnimation = dynamic(
  () => import(/* webpackChunkName: "lazy-aboutus-anim" */ './HeroAnimation'),
  {
    loading: () => null,
  },
);
